import { render, staticRenderFns } from "./HomeGameCharacter.vue?vue&type=template&id=68807817&scoped=true&"
import script from "./HomeGameCharacter.vue?vue&type=script&lang=js&"
export * from "./HomeGameCharacter.vue?vue&type=script&lang=js&"
import style0 from "./HomeGameCharacter.vue?vue&type=style&index=0&id=68807817&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68807817",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68807817')) {
      api.createRecord('68807817', component.options)
    } else {
      api.reload('68807817', component.options)
    }
    module.hot.accept("./HomeGameCharacter.vue?vue&type=template&id=68807817&scoped=true&", function () {
      api.rerender('68807817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeGameCharacter.vue"
export default component.exports